import { getAccessToken } from '../../services/data/accessToken'
import {
  SET_MASKED_DATA,
  SET_TIME_OUT_NOTICE,
  SET_REDIRECT_AFTER_AUTH,
  SET_DELETE_ACCOUNT_REQUESTID,
  SET_OTP_TO_MOBILE,
} from './actions/types'

const accessToken = getAccessToken()

const INITIAL_STATE = {
  otpToMobile: false,
  accessToken: accessToken || null,
  showTimeOutNotice: false,
  redirectAfterAuth: null,
  deleteRequestId: null,
  maskedData: {},
}

function setTimeOutNotice(state, action) {
  return {
    ...state,
    showTimeOutNotice: action.payload.showTimeOutNotice,
  }
}

function setRedirectAfterAuth(state, action) {
  return {
    ...state,
    redirectAfterAuth: action.payload.redirectAfterAuth,
  }
}

function setDeleteOtpToMobile(state, action) {
  return {
    ...state,
    otpToMobile: action.payload.otpToMobile,
  }
}

function setDeleteMaskedData(state, action) {
  return {
    ...state,
    maskedData: action.payload.maskedData,
  }
}

function setDeleteRequestId(state, action) {
  return {
    ...state,
    deleteRequestId: action.payload.deleteRequestId,
  }
}

function reducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case SET_TIME_OUT_NOTICE:
      return setTimeOutNotice(state, action)
    case SET_REDIRECT_AFTER_AUTH:
      return setRedirectAfterAuth(state, action)
    case SET_OTP_TO_MOBILE:
      return setDeleteOtpToMobile(state, action)
    case SET_MASKED_DATA:
      return setDeleteMaskedData(state, action)
    case SET_DELETE_ACCOUNT_REQUESTID:
      return setDeleteRequestId(state, action)
    default:
      break
  }
  return state
}

export default reducer
